import React from 'react';
import { BookOpen, Calculator, MapPin } from 'lucide-react';
import { ShareButton } from '../../../components/ShareButton';

const STATS = [
  { v: '9,000+', l: 'Affiliate Gyms' },
  { v: '1M+', l: 'Registered Athletes' },
  { v: '30+', l: 'Countries' },
  { v: '8', l: 'Brutal Stations' },
];

export const HeroSection = () => (
  <section className="relative min-h-[70vh] flex items-center overflow-hidden">
    <video
      autoPlay
      muted
      loop
      playsInline
      className="absolute inset-0 w-full h-full object-cover opacity-30"
      src="https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/heww5odd_Daniel%20and%20Elli%20Individual%20Clips00415387.mov"
      data-testid="hyrox-hero-video"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/60" />
    <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(232,255,0,0.4) 40px, rgba(232,255,0,0.4) 80px)' }} />
    <div className="container-ninja relative z-10 py-16">
      <div className="max-w-3xl">
        <span className="inline-block px-4 py-1.5 bg-[#e8ff00] text-black text-xs font-heading tracking-widest uppercase mb-6">
          The Complete HYROX Hub
        </span>
        <h1 className="text-4xl sm:text-5xl md:text-7xl text-white font-heading leading-[0.95] mb-6" data-testid="hyrox-hero-title">
          YOUR COMPLETE <span className="text-[#e8ff00]">HYROX</span> COMMAND CENTER
        </h1>
        <p className="text-zinc-400 text-lg md:text-xl max-w-xl mb-8">
          Training guides, race tools, gym finder, equipment deals and everything you need to dominate your next HYROX race.
        </p>
        <div className="flex flex-wrap gap-3">
          <a href="#guides" className="px-6 py-3 bg-[#e8ff00] text-black font-heading text-sm uppercase tracking-wider hover:opacity-90 transition-opacity inline-flex items-center gap-2" data-testid="hero-guides-btn">
            Training Guides <BookOpen className="w-4 h-4" />
          </a>
          <a href="#tools" className="px-6 py-3 border border-[#e8ff00]/40 text-[#e8ff00] font-heading text-sm uppercase tracking-wider hover:bg-[#e8ff00]/10 transition-colors inline-flex items-center gap-2" data-testid="hero-tools-btn">
            Race Tools <Calculator className="w-4 h-4" />
          </a>
          <a href="#gyms" className="px-6 py-3 border border-zinc-700 text-zinc-400 font-heading text-sm uppercase tracking-wider hover:border-zinc-500 hover:text-white transition-colors inline-flex items-center gap-2" data-testid="hero-gyms-btn">
            Find a Gym <MapPin className="w-4 h-4" />
          </a>
          <ShareButton title="Your Complete HYROX Command Center | NinjAthlete" path="/hyrox" accentColor="#e8ff00" />
        </div>
      </div>
      <div className="flex gap-8 md:gap-12 mt-12 flex-wrap">
        {STATS.map((s) => (
          <div key={s.l} className="text-center">
            <p className="text-3xl md:text-4xl font-heading text-[#e8ff00]">{s.v}</p>
            <p className="text-zinc-500 text-[10px] uppercase tracking-wider">{s.l}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
